import React from 'react'
import Button from 'react-bootstrap/Button'
import { useNavigate } from "react-router-dom";
import axios from 'axios';


function ThemeLogout() {
  let navigate = useNavigate();
  
  let authentication = JSON.parse(localStorage.getItem("authenticated"));
  let sessid = authentication.sessid;
  let session_name = authentication.session_name;
  let session_token = authentication.token

  const Logout = async (e) => {
    e.preventDefault();
    await axios.post(process.env.REACT_APP_DRUPAL_PATH+'/mp_authentication_api/user/logout',{},
    { 
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": session_token,
        "Authentication": session_name+"="+sessid,
        "Cache-Control": "no-cache",
    },
    })
    .then(function () {
      navigate("/login", { replace: true });
    })
    .catch(function (error) {
      console.log(error);
    });
    console.log(authentication.sessid);
    
    
  }

  return (
    <div className="logout-button">
      <Button 
        className="w-100" 
        variant="transparent"
        onClick={Logout}
      >
          Logout
      </Button>
    </div>
  )
}

export default ThemeLogout